<template>
    <fade-up-animation :element="() => $refs.section">
        <section class="item-card-section" ref="section">
            <h2 class="title" v-test:title>{{ title }}</h2>
            <base-carousel
                :breakpoints="carouselBreakpoints"
                navigation
                always-show-navigation
            >
                <item-card
                    v-for="(item, i) in items"
                    :slot="`slot_${ i }`"
                    :key="item.name"
                    v-bind="item"
                />
            </base-carousel>
        </section>
    </fade-up-animation>
</template>

<script>
    import ItemCard from '../../molecules/ItemCard/ItemCard';
    import BaseCarousel from '../../molecules/BaseCarousel/BaseCarousel';

    export default {
        name: 'item-card-section',

        components: { BaseCarousel, ItemCard },

        props: {
            title: {
                type: String,
                required: true,
            },

            items: {
                type: Array,
                required: true,
            },
        },

        computed: {
            /**
             * Return the carousel breakpoints.
             *
             * @returns {object}
             */
            carouselBreakpoints() {
                return {
                    0: {
                        slidesPerView: 1.2,
                        spaceBetween: 20,
                    },
                    400: {
                        slidesPerView: 1.5,
                        spaceBetween: 50,
                    },
                    768: {
                        slidesPerView: 2,
                        spaceBetween: 80,
                    },
                    1377: {
                        slidesPerView: 2,
                        spaceBetween: 110,
                    },
                };
            },
        },
    };
</script>

<style lang="scss" scoped>
    .item-card-section {
        padding-top: 32px;
        padding-bottom: 20px;
        @include media-breakpoint-up(md) {
            padding-top: 55px;
        }
    }

    .title {
        text-align: center;
        font-size: rem(40px);
        line-height: rem(44px);
        font-weight: 700;
        margin-bottom: 21px;
        @include media-breakpoint-up(lg) {
            font-size: rem(48px);
            line-height: rem(56px);
            margin-bottom: 16px;
        }
    }

    .item-card {
        width: 100%;
    }
</style>
